import { createReducer } from '@reduxjs/toolkit'
import { AlertManual } from 'interfaces/api/alertManual.interfaces'
import { createBuilder } from 'packages/redux-toolkit'

import { getAllAlertManuals, updateAlertManual } from './actions'

interface AlertState {
  single: {
    loading: boolean
  }
  loading: boolean
  count: number
  items: AlertManual[]
}

const initialState: AlertState = {
  single: {
    loading: false,
  },
  loading: false,
  count: 0,
  items: [],
}

export const alertManualsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllAlertManuals.pending, (state) => {
      state.loading = true
    })
    .addCase(getAllAlertManuals.fulfilled, (state, { payload }) => {
      state.items = payload.results
      state.count = payload.count
      state.loading = false
    })
    .addCase(getAllAlertManuals.rejected, (state) => {
      state.loading = false
    })
    .addCase(updateAlertManual.pending, (state) => {
      state.single.loading = true
    })
    .addCase([updateAlertManual.fulfilled, updateAlertManual.rejected], (state) => {
      state.single.loading = false
    })
})
